export const itineraryExamples = [
  {
    id: 'feat-honeymoon',
    versionId: 'v2',
    label: 'Honeymooners',
    photoAlt: 'Priya and Nick laughing together after a Kauai mountain-tubing adventure',
    testimonial: {
      quote: "Planning a wedding is stressful. What a blessing to let Alaka'i Aloha handle the honeymoon!"
    },
    photo: '/images/trip-photos/feat-honeymoon.webp'
  },
  {
    id: 'feat-family-youngkids',
    versionId: 'v1',
    label: 'Family with a young child',
    photoAlt: 'Rosa and Michael examining a tiny beach discovery with their daughter Sofia',
    testimonial: {
      quote: "We've already decided that we're coming back next year. Great trip!"
    },
    photo: '/images/trip-photos/feat-family-youngkids.webp'
  },
  {
    id: 'feat-family-teens',
    versionId: 'v1',
    label: 'Family with teens',
    photoAlt: 'Jamal, Tracy, Malik, and Nia laughing after paddling the Wailua River',
    testimonial: {
      quote: "We usually waste half the trip negotiating what to do next. Alaka'i Aloha handed us a roadmap we were all happy to follow."
    },
    photo: '/images/trip-photos/feat-family-teens.webp'
  },
  {
    id: 'feat-retired-couple',
    versionId: 'v1',
    label: 'Retired couple',
    photoAlt: 'Linda and Howard laughing together beside their golf cart on Kauai',
    testimonial: {
      quote: "If you knew how long it takes us to agree on what to watch on Netflix, you'd realize how badly we need a service like this!"
    },
    photo: '/images/trip-photos/feat-retired-couple.webp'
  },
  {
    id: 'feat-friends-group',
    versionId: 'v1',
    label: 'Friends getaway',
    photoAlt: 'Six friends sharing snacks and laughs after a muddy North Shore hike',
    testimonial: {
      quote: "Six people. Zero drama. One big adventure. Best group trip ever."
    },
    photo: '/images/trip-photos/feat-friends-group.webp'
  },
  {
    id: 'feat-multigen-family',
    versionId: 'v1',
    label: 'Multigenerational family',
    photoAlt: 'Three generations building an imperfect sandcastle together at a Poipu beach',
    testimonial: {
      quote: "Not easy to dial in details that work for a 7-year-old, a 70-year-old, and everyone in between. Thank you!"
    },
    photo: '/images/trip-photos/feat-multigen-family.webp'
  },
  {
    id: 'feat-solo-traveler',
    versionId: 'v1',
    label: 'Solo traveler',
    photoAlt: 'Susan holding a trail map at a cloudy Waimea Canyon overlook',
    testimonial: {
      quote: "I scoured the web for the 'best 5-day Kauai itinerary'. None of those generic templated trips came close to what Alakai Aloha put together JUST FOR ME."
    },
    photo: '/images/trip-photos/feat-solo-traveler.webp'
  }
];

export const oahuItineraryExamples = [
  {
    id: 'feat-oahu-waikiki-honeymoon',
    versionId: 'v1',
    label: 'Waikīkī honeymoon',
    photoAlt: 'Morgan and Eli laughing together on the Waikiki beachfront after picking up malasadas',
    testimonial: {
      quote: 'We got the honeymoon feeling without spending the honeymoon making plans.'
    },
    photo: '/images/trip-photos/feat-oahu-waikiki-honeymoon.webp'
  },
  {
    id: 'feat-oahu-ko-olina-young-family',
    versionId: 'v1',
    label: 'Ko Olina family with young kids',
    photoAlt: 'Priyanka, Daniel, Maya, and Leo drying off together after swimming at a Ko Olina lagoon',
    testimonial: {
      quote: 'The afternoon breaks saved all four of us. Nobody melted down—including the adults.'
    },
    photo: '/images/trip-photos/feat-oahu-ko-olina-young-family.webp'
  },
  {
    id: 'feat-oahu-waikiki-multigen',
    versionId: 'v1',
    label: 'Waikīkī multigenerational family',
    photoAlt: 'Three generations of one family together on Waikiki Beach at sunset',
    testimonial: {
      quote: 'Six people, three generations, and somehow every day had something for everyone.'
    },
    photo: '/images/trip-photos/feat-oahu-waikiki-multigen.webp'
  },
  {
    id: 'feat-oahu-waikiki-friends',
    versionId: 'v1',
    label: 'Waikīkī friends getaway',
    photoAlt: 'Four friends laughing over lunch at North Shore food trucks',
    testimonial: {
      quote: 'Great food, beach time, and almost no 7 a.m. alarms. They understood the assignment.'
    },
    photo: '/images/trip-photos/feat-oahu-waikiki-friends.webp'
  },
  {
    id: 'feat-oahu-north-shore-siblings',
    versionId: 'v1',
    label: 'North Shore sibling trip',
    photoAlt: 'Mateo, Sofia, and Lucas laughing together after a North Shore surf lesson',
    testimonial: {
      quote: 'We stopped debating and started surfing. That alone was worth it.'
    },
    photo: '/images/trip-photos/feat-oahu-north-shore-siblings.webp'
  },
  {
    id: 'feat-oahu-windward-couple',
    versionId: 'v1',
    label: 'Windward Coast couple',
    photoAlt: 'Aisha and Lena sharing a laugh after kayaking on Kaneohe Bay',
    testimonial: {
      quote: 'It gave us the quieter Oʻahu trip we hoped existed.'
    },
    photo: '/images/trip-photos/feat-oahu-windward-couple.webp'
  },
  {
    id: 'feat-oahu-solo-history',
    versionId: 'v1',
    label: 'Solo history traveler',
    photoAlt: 'Robert holding his visitor guide on the grounds of Iolani Palace',
    testimonial: {
      quote: 'I saw the history I came for without feeling like I was following a tour bus.'
    },
    photo: '/images/trip-photos/feat-oahu-solo-history.webp'
  }
];

export const mauiItineraryExamples = [
  {
    id: 'feat-maui-wailea-honeymoon',
    versionId: 'v1',
    label: 'Wailea honeymoon',
    photoAlt: 'Olivia and Marcus laughing over hot coffee after sunrise at Haleakala',
    testimonial: {
      quote: 'We had sunrise, snorkeling, and plenty of time to do absolutely nothing. Perfect honeymoon.'
    },
    photo: '/images/trip-photos/feat-maui-wailea-honeymoon.webp'
  },
  {
    id: 'feat-maui-kihei-family-teens',
    versionId: 'v1',
    label: 'Kīhei family with teens',
    photoAlt: 'Elena, Victor, Lucia, and Nico relaxing on a Kihei beach after snorkeling',
    testimonial: {
      quote: 'We saw a ton of Maui without making the kids live in the rental car.'
    },
    photo: '/images/trip-photos/feat-maui-kihei-family-teens.webp'
  },
  {
    id: 'feat-maui-kaanapali-young-family',
    versionId: 'v1',
    label: 'Kāʻanapali family with young kids',
    photoAlt: 'Grace, Aaron, Zoe, and a sleepy Miles wrapping up a Kaanapali beach day',
    testimonial: {
      quote: 'The plan worked around nap time instead of pretending nap time didn’t exist.'
    },
    photo: '/images/trip-photos/feat-maui-kaanapali-young-family.webp'
  },
  {
    id: 'feat-maui-napili-repeat-couple',
    versionId: 'v1',
    label: 'Nāpili repeat visitors',
    photoAlt: 'Denise and Paul eating fish tacos after an early snorkel at Napili Bay',
    testimonial: {
      quote: 'It found us new favorites without taking away the Maui routines we already love.'
    },
    photo: '/images/trip-photos/feat-maui-napili-repeat-couple.webp'
  },
  {
    id: 'feat-maui-kapalua-retired-couple',
    versionId: 'v1',
    label: 'Kapalua retired couple',
    photoAlt: 'Mei and Thomas laughing together on the Kapalua Coastal Trail',
    testimonial: {
      quote: 'Every day felt considered, never crowded.'
    },
    photo: '/images/trip-photos/feat-maui-kapalua-retired-couple.webp'
  },
  {
    id: 'feat-maui-kihei-friends',
    versionId: 'v1',
    label: 'Kīhei friends getaway',
    photoAlt: 'Four friends bundled under a blanket for a windy Haleakala sunset',
    testimonial: {
      quote: 'Four friends, one plan, zero group-chat negotiations before breakfast.'
    },
    photo: '/images/trip-photos/feat-maui-kihei-friends.webp'
  },
  {
    id: 'feat-maui-hana-couple',
    versionId: 'v1',
    label: 'Hāna couple',
    photoAlt: 'Nia and Camille laughing in the rain on a muddy East Maui waterfall trail',
    testimonial: {
      quote: 'We slowed down enough to actually experience Hāna.'
    },
    photo: '/images/trip-photos/feat-maui-hana-couple.webp'
  }
];

export const bigIslandItineraryExamples = [
  {
    id: 'feat-big-island-kona-family-teens',
    versionId: 'v1',
    label: 'Kona family with teens',
    photoAlt: 'Jamal, Rochelle, Imani, and Caleb celebrating after an evening manta snorkel',
    testimonial: {
      quote: 'The kids got their big adventures, and we still got mornings without alarms.'
    },
    photo: '/images/trip-photos/feat-big-island-kona-family-teens.webp'
  },
  {
    id: 'feat-big-island-kohala-multigen',
    versionId: 'v1',
    label: 'Kohala Coast multigenerational family',
    photoAlt: 'Three generations sharing dessert after a family dinner on the Kohala Coast',
    testimonial: {
      quote: 'It made room for the grandparents, the kids, and Thanksgiving—without turning it into a production.'
    },
    photo: '/images/trip-photos/feat-big-island-kohala-multigen.webp'
  },
  {
    id: 'feat-big-island-kona-friends',
    versionId: 'v1',
    label: 'Kona friends getaway',
    photoAlt: 'Ben, Arjun, Kai, and Noah swapping stories after a Kona dive and snorkel outing',
    testimonial: {
      quote: 'The divers could dive, the snorkelers had a plan, and nobody felt like the backup group.'
    },
    photo: '/images/trip-photos/feat-big-island-kona-friends.webp'
  },
  {
    id: 'feat-big-island-waikoloa-anniversary',
    versionId: 'v1',
    label: 'Waikoloa anniversary couple',
    photoAlt: 'Jada and Simone laughing over a failed phone-timer photo at sunset in Waikoloa',
    testimonial: {
      quote: 'Our anniversary day felt special without feeling staged.'
    },
    photo: '/images/trip-photos/feat-big-island-waikoloa-anniversary.webp'
  },
  {
    id: 'feat-big-island-hilo-solo',
    versionId: 'v1',
    label: 'Solo Hilo photographer',
    photoAlt: 'Priya checking a photograph beside a rainy Hilo waterfall',
    testimonial: {
      quote: 'I never had to wonder if I was taking on too much alone.'
    },
    photo: '/images/trip-photos/feat-big-island-hilo-solo.webp'
  },
  {
    id: 'feat-big-island-volcano-family',
    versionId: 'v1',
    label: 'Volcano family',
    photoAlt: 'Mei, Daniel, Hannah, and Eric laughing together at a rainy volcano overlook',
    testimonial: {
      quote: 'It gave us plenty of volcano time without making every day another hike.'
    },
    photo: '/images/trip-photos/feat-big-island-volcano-family.webp'
  },
  {
    id: 'feat-big-island-kona-repeat-couple',
    versionId: 'v1',
    label: 'Kona repeat visitors',
    photoAlt: 'Curtis and Linda enjoying a relaxed morning coffee tasting above the Kona coast',
    testimonial: {
      quote: 'It understood we didn’t need more sights—we needed a better rhythm.'
    },
    photo: '/images/trip-photos/feat-big-island-kona-repeat-couple.webp'
  }
];

export const allItineraryExamples = [
  ...itineraryExamples,
  ...oahuItineraryExamples,
  ...mauiItineraryExamples,
  ...bigIslandItineraryExamples
];

export function getItineraryExamplesForIsland(islandKey) {
  switch (islandKey) {
    case 'kauai':
      return itineraryExamples;
    case 'oahu':
      return oahuItineraryExamples;
    case 'maui':
      return mauiItineraryExamples;
    case 'big_island':
      return bigIslandItineraryExamples;
    default:
      return [];
  }
}
